import { render } from "./news.vue?vue&type=template&id=5958ab4b&scoped=true&ts=true"
import script from "./news.vue?vue&type=script&lang=ts"
export * from "./news.vue?vue&type=script&lang=ts"

import "./news.vue?vue&type=style&index=0&id=5958ab4b&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5958ab4b"]])

export default __exports__